<div class="flex flex-col">
  <div class="flex flex-row">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
                    'bg-gray-600': sharedService.userTheme === 'dark',
                    'bg-indigo-50': sharedService.userTheme === 'light'}">
      <div class="flex flex-row padding10">
        <h5>Re-License Labs</h5>
      </div>
    </mat-card>
  </div>

  <div class="flex flex-col" *ngIf="editMode == 'process'">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
            'bg-gray-700': sharedService.userTheme === 'dark',
            'bg-indigo-50': sharedService.userTheme === 'light'}">
      <mat-card-content>
        <span>Using this feature will create a blank License/Cash Record for the all active SOA or HST labs, setting the
          Expiration date to the date you enter below.</span><br /><br />
        <ol>
          <li>Enter expiration date for next license period.</li>
          <li>Select the type of re-license you would like to generate.</li>
          <li>Click the <strong>Re-license</strong> button.</li>
        </ol>
      </mat-card-content>
    </mat-card>
    <form [formGroup]="formGroup">
      <div class="flex flex-row">

        <mat-form-field Style="padding-right:20px">
          <mat-label>Enter Re-License Expiration Date</mat-label>
          <input matInput [matDatepicker]="RelicenseDate" formControlName="RelicenseDate">
          <mat-datepicker-toggle matSuffix [for]="RelicenseDate"></mat-datepicker-toggle>
          <mat-datepicker #RelicenseDate></mat-datepicker>
          <mat-error *ngIf="formGroup.get('RelicenseDate').invalid">
            Invalid Date.
          </mat-error>
        </mat-form-field>

        <mat-form-field Style="padding-right:20px">
          <mat-label>Lab Type</mat-label>
          <mat-select formControlName="LicenseType">
            <mat-option value=""></mat-option>
            <mat-option value="HST">HST</mat-option>
            <mat-option value="SOA">SOA</mat-option>
          </mat-select>
          <mat-error *ngIf="formGroup.get('LicenseType').invalid">
            Required field.
          </mat-error>
        </mat-form-field>

        <div>
          <button type="button" mat-raised-button color="primary" (click)="relicense()">Re-license</button>
        </div>

      </div>
    </form>
  </div>


  <!-- List Mode -->
  <div class="flex flex-row" *ngIf="editMode == 'list'">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
            'bg-gray-700': sharedService.userTheme === 'dark',
            'bg-indigo-50': sharedService.userTheme === 'light'}">
      <mat-card-content>
        <div class="flex flex-col">
          <div class="flex flex-col">
            <h6 *ngIf="type =='HST'">HST Relicense Report on {{currentDate}}</h6>
            <h6 *ngIf="type =='SOA'">SOA Relicense Report on {{currentDate}}</h6>
            <br /> <br />
            <span>Labs Re-licensed on {{licenseDate}}</span>
            <br />
            <span>Total Record Count {{list.length}}</span>
          </div>
          <div class="flex flex-row">
            <mat-form-field class="flex-1 min-w-[30%] sm:min-w-full">
              <input matInput id="listFilter" (keyup)="filterTable($event)" placeholder="Filter"
                value="{{listFilter}}" />

              <button *ngIf="listFilter" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <div style="overflow-x:auto">
            <div class="flex flex-row">
              <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort"
                class="mat-elevation-z8 w-full" matSortActive="labName" matSortDirection="asc">
                <ng-container matColumnDef="stateNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>State Number</th>
                  <td mat-cell *matCellDef="let item">{{item.stateNumber}}</td>
                </ng-container>
                <ng-container matColumnDef="labName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Lab Name</th>
                  <td mat-cell *matCellDef="let item">{{item.labName}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </div>
          </div>
          <mat-paginator [pageSizeOptions]="getPageSizeOptions()" #TablePaginator="matPaginator" showFirstLastButtons>
          </mat-paginator>
        </div>

      </mat-card-content>

    </mat-card>
  </div>

</div>